import Page from '../../classes/Page'
import { app } from '../../utils/store'

export default class Blog extends Page{
    constructor(){
        super({
            id : 'blog',
            element: '[data-app-page]',
            // elements: { key : 'nodeElementSelector' }
        })
    }

    create() {
        super.create()
    }
    
    addEventListeners() {
        
    }

    destroy(){ 
        super.destroy()
    }
}